/**
 * jQuery lightzoom v1.1.0
 * Copyright 2020
 * Contributing Author: Aleksey Savin
 * E-mail: asavin.work@yandex.ru
 */

import { transition } from "d3";

 ;( function( $, window, document, undefined ) {

 	"use strict";

 		// Create the defaults once
 		var pluginName = "lightzoom";
 		var	defaults = {
        boxClass:               "",
        speed:                  400,
        imgPadding:             10,
        overlayOpacity:         "0.5",
        overlayColor:           "",
        viewTitle:              false,
        titleColor:             "",
        isOverlayClickClosing:  false,
        isWindowClickClosing:   false,
        isEscClosing:           false
 			};

    var html  = '<div id="lz-container">\
                   <div id="lz-box">\
                     <div id="lz-overlay"></div>\
                   </div>\
                 <div id="lz-loading-center">\
                   <div class="lz-loading-center-box">\
                     <div class="lz-object" id="lz-object_one"></div>\
                     <div class="lz-object" id="lz-object_two"></div>\
                     <div class="lz-object" id="lz-object_three"></div>\
                   </div>\
                 </div>\
                </div>';

 		// The actual plugin constructor
 		function Plugin ( element, options ) {
 			this.element = element;

 			this.settings = $.extend( {}, defaults, options );
 			this._defaults = defaults;
 			this._name = pluginName;
 			this.init();
 		}

 		// Avoid Plugin.prototype conflicts
 		$.extend( Plugin.prototype, {
 			init : function() {

        var $this = this;

        $this.build();

        $( document ).on( 'click', '#lz-close', function( event ) {
          event.preventDefault();
          $this.closeZoom();
        });

        if ( $this.settings.isWindowClickClosing ) {
          $( document ).on( 'click', '#lz-container', function( event ) {
            $this.closeZoom();
          });
        } else if ( $this.settings.isOverlayClickClosing ) {
          $( document ).on( 'click', '#lz-overlay', function( event ) {
            $this.closeZoom();
          });
        }

        if ( $this.settings.isEscClosing ) {
          $( document ).keydown( function( event ) {
            if ( event.which === 27 ) {
              $this.closeZoom();
            }
          });
        }

        $this.resize();
 			},

      build : function () {
        var $this = this;

        $(this.element).on( 'click', function( event ) {
          event.preventDefault();

          $( 'body' ).append( html );

          var lz      = $( '#lz-box' ),
            img       = $(this).children('img'),
            src       = $(this).attr('href'),
            overlayCss = {};

          if ( $this.settings.boxClass != "" ) {
            lz.addClass($this.settings.boxClass);
          }

          var title = img.attr('title');

          overlayCss = {
            opacity : $this.settings.overlayOpacity,
            backgroundColor: $this.settings.overlayColor
          };

          $('#lz-overlay').css( overlayCss );
          $('#lz-container').fadeIn({ 'display' : 'block' });

          $(new Image()).attr('src', src).on( 'load', function() {

            lz.append( '<img src="' + src + '">' );

            $this.showTitle( title );
            $this.setTitleColor( title );
            $this.setPadding( title );
            $this.setDim();

            lz.append( '<a href="#" id="lz-close" title="Close">Close</a>' );

            $('#lz-loading-center').remove();

            $('#lz-box img').animate(
              {
                opacity: 1
              }, 
              $this.settings.speed
            );
            $('#lz-box img').addClass('image-loaded');

          });

        });

      },

      showTitle : function (title) {
        if ( this.settings.viewTitle && title ) {
          $( '#lz-box' ).append( '<p>' + title + '</p>' );
        }
      },

      setTitleColor : function (title) {
        if ( this.settings.titleColor != "" && title ) {
          $('#lz-box p').css('color', this.settings.titleColor);
        }
      },

      setPadding : function (title) {
        var padding = 0,
         backgroundColor = this.settings.imgPadding > 0 ? "#FFF" : "none",
         imgCss = {};

        if ( this.settings.viewTitle && title ) {
          padding = this.settings.imgPadding + "px " + this.settings.imgPadding + "px " + ( this.settings.imgPadding + 30 ) + "px " + this.settings.imgPadding + "px";
        } else {
          padding = this.settings.imgPadding;
        }

        imgCss = {
          padding         : padding,
          backgroundColor : backgroundColor,
        }

        $('#lz-box img').css( imgCss );
      },

			setDim : function () {

				var width, height, imgCss = {};
        var winWidth = window.innerWidth ? window.innerWidth : $( window ).width();
        var winHeight = window.innerHeight ? window.innerHeight : $( window ).height();
        var orientationType;

        if ( winWidth > winHeight ) {
          width  = "95%";
          height = "80%";
        } else {
          width  = "95%";
          height = "100%";
        }

				// Reset dimensions on mobile orientation change
				if ( 'onorientationchange' in window ) {

					window.addEventListener( 'orientationchange', function() {

            // if (window.orientation === 0) {
            //   width = "80%";
            //   height = "100%";
            // } else if (window.orientation === 90 || window.orientation === -90) {
            //   width = "95%";
            //   height = "80%";
            // }
            if (screen.orientation.type == 'landscape-primary' || screen.orientation.type == 'landscape-secondary') {
              orientationType = 'landscape'
            } else {
              orientationType = 'portrait';
            }
					}, false );

				}

				imgCss = {
            maxWidth        : width,
            maxHeight       : height,
            transition      : 'max-height 8s ease-out 9.5s, max-width 8s ease-out 9.5s',
				};

        console.log(orientationType);
        //return;

				// $( '#lz-box img' ).css( imgCss );

        $('#lz-box img').addClass(orientationType);

			},

      closeZoom : function () {
        var $this = this;

        $('#lz-container').fadeOut($this.settings.speed, function() {
          $this.destroy();
        });

			},

			resize : function () {
				var $this = this;

				$( window ).resize( function() {
					$this.setDim();
				} ); // .resize();
			},

      destroy : function () {
        $('#lz-container').remove();
      },

 		});

 		$.fn[ pluginName ] = function( options ) {
 			return this.each( function() {
 				if ( !$.data( this, "plugin_" + pluginName ) ) {
 					$.data( this, "plugin_" +
 						pluginName, new Plugin( this, options ) );
 				}
 			} );
 		};

 } )( jQuery, window, document );
